import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Box, Anchor, Text } from 'wt-ui';
import ReactMarkdown from 'react-markdown';

import i18next from '../../translations/i18n';

import VariationContext from '../../services/VariationContext';
import variations from '../../services/variations';

import DynamicText from '../../services/DynamicText';

const computeFooterText = (fundData) => {
  let text = '';
  const categoryKey = `${DynamicText.getCategoryKey(fundData)}_footer`;
  if (i18next.exists(categoryKey)) {
    text = i18next.t(categoryKey);
  }
  return DynamicText.replaceMarkdownText(text, fundData);
};

const getDisclaimer = (fundData) => {
  if (fundData.isSnL) {
    return i18next.t('disclaimerSL');
  }
  return i18next.t('disclaimerDefault');
};

const TableFooterText = ({ fundData }) => {
  const variation = useContext(VariationContext);
  if (variation === variations.embedded) {
    return (
      <Box background="transparent" direction="row" alignSelf="start" gap="xsmall">
        <Text>For more information and to customise this table please head to our </Text>
        <Anchor
          href={`/${(
            window.performanceApp.isoCode || 'en-gb'
          ).toLowerCase()}/product-performance?ticker=${fundData.bloombergTickerPrimary || fundData.bloombergTicker}`}
          target="_bank"
          primary
        >
          Product Performance Tool
        </Anchor>
      </Box>
    );
  }
  return (
    <>
      <Box background="transparent">
        <ReactMarkdown source={computeFooterText(fundData)} />
      </Box>
      <Box background="transparent" pad={{ top: 'medium' }}>
        <ReactMarkdown source={getDisclaimer(fundData)} />
      </Box>
    </>
  );
};

TableFooterText.propTypes = {
  fundData: PropTypes.shape({
    bloombergTicker: PropTypes.string,
    bloombergTickerPrimary: PropTypes.string,
  }).isRequired,
};

export default TableFooterText;
